// extracted by mini-css-extract-plugin
export var base = "text-module--base--dc622";
export var bold = "text-module--bold--51397";
export var centered = "text-module--centered--8c1e1";
export var error = "text-module--error--89971";
export var link = "text-module--link--9a88c";
export var medium = "text-module--medium--d6873";
export var pressKit = "text-module--pressKit--d707c";
export var small = "text-module--small--6e470";